import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const pharmacyApi = {
  async getQueue(params = {}) {
    const response = await apiClient.get("/pharmacy/queue", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async getPrescriptionDetail(id) {
    const response = await apiClient.get(`/pharmacy/prescriptions/${id}`);
    return unwrapEnvelope(response.data, null);
  },

 async issueAndDispense(id) {
  console.log("zzzSending request to issue invoice and dispense prescription with ID", id);

  try {
    const response = await apiClient.post(`/pharmacy/prescriptions/${id}/issue-dispense`, {});

    console.log("Received response from issue and dispense request for prescription ID", id, "with data", response.data);

    return unwrapEnvelope(response.data, null);
  } catch (error) {
    console.log("Error occurred while issuing invoice and dispensing prescription with ID", id, ":", error);
    console.error("❌ ISSUE DISPENSE ERROR", {
      id,
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });

    throw error; // important
  }
  console.log("Finished issueAndDispense function for prescription ID", id);
},

  async createReturn(payload = {}) {
    const response = await apiClient.post("/pharmacy/returns", payload);
    return unwrapEnvelope(response.data, null);
  }
};
